import { render, staticRenderFns } from "./login35.vue?vue&type=template&id=29ffe031&scoped=true&"
import script from "./login35.vue?vue&type=script&lang=ts&"
export * from "./login35.vue?vue&type=script&lang=ts&"
import style0 from "./login35.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./login35.vue?vue&type=style&index=1&id=29ffe031&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ffe031",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ffe031')) {
      api.createRecord('29ffe031', component.options)
    } else {
      api.reload('29ffe031', component.options)
    }
    module.hot.accept("./login35.vue?vue&type=template&id=29ffe031&scoped=true&", function () {
      api.rerender('29ffe031', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/home/modules/login/login35.vue"
export default component.exports